import api from "api";
import { popinfo } from "component/Fancybox/Fancybox";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";

const FollowButton = connect(stateMap)(props => {
    const [isFollow, setIsFollow]   = useState(false);
    const [isProcess, setIsProcess] = useState(false);

    const FollowUser = () => {

        if(!props.auth.user)
        {
            return;
        }

        if(!props.user)
        {
            return ;
        }

        if(props.auth.user.UserID == props.user.UserID)
        {
            return;
        }

        setIsProcess(true);

        api('/Follow', 'post', {
            follow : props.user.UserID
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                setIsProcess(false);

                setIsFollow(!isFollow);
            })
            .catch(error => {
                setIsProcess(false);
                popinfo('error', 'Following ' + props.user.UserFirstName, error);
            })
    }

    useEffect(() => {
        if(!props.auth.user)
        {
            return;
        }

        if(!props.user)
        {
            return;
        }

        if(props.auth.user.UserID == props.user.UserID)
        {
            return;
        }

        api('/Follow', 'get', {
            follower : props.auth.user.UserID
            ,following : props.user.UserID
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                setIsProcess(false);
                setIsFollow(response.follow.length > 0);
            })

    }, [props.auth.user, props.user]);

    return (
        props.auth.user.UserID != props.user.UserID && (
            isProcess ? <span className="skeleton"></span> :
            <button className={props.className || "btn btn-primary" } onClick={(e) => {
                e.preventDefault();
                FollowUser()
            }}>{isFollow ? 'Unfollow' : 'Follow'}</button>
        )
    )
});

export {FollowButton}